// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__jU5g4","chartContainer":"style_chartContainer__LeTBR","table":"style_table__vdFhB"};